module.exports = "/img/_/_/_/assets/images/creeper/battle/rare//14.jpg?9cf55282753b9b156fc141208ab40551";